// ** IMPORTANT **: Keep in sync with functions/src/index.ts AUTH_ACTION_MODE_TYPE
export enum AUTH_ACTION_MODE_TYPE {
    resetPassword = 'resetPassword',
    legacyResetPassword = 'action',
    recoverEmail = 'recoverEmail',
    verifyEmail = 'verifyEmail',
    unsubscribe = 'unsubscribe',
    claimBookInvite = 'claimBookInvite',
    claimDiscount = 'claimDiscount',
    openProfile = 'openProfile',
}
